module.exports = __webpack_public_path__ + "img/hannah-avatar.822d256b.png";